export default "__VITE_ASSET__CdCdknyO__"